const ServiceDepartment = {

    // FIELDS
    "service_department": "Service Department",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Service Department",
    "filter_title": "Service Department Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",

    // ERROR
    "error_name": "Enter Service Department Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default ServiceDepartment;
